import { render, staticRenderFns } from "./UserProfilePicture.vue?vue&type=template&id=1430eb92&lang=html&"
import script from "./UserProfilePicture.vue?vue&type=script&lang=js&"
export * from "./UserProfilePicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports